"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createFragment = createFragment;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Note: createRange and Range must be polyfilled on older browsers with
//       https://github.com/timdown/rangy
function createFragment(html) {
  /**
   * createFragment takes in an HTML string and outputs a DOM element that is
   * treated as if it originated on the page "like normal".
   * @type {Node} - https://developer.mozilla.org/en-US/docs/Web/API/Node
   */
  // Create a range to ensure that scripts are invoked from within the HTML
  var range = document.createRange();
  var fragment = range.createContextualFragment(html);
  return fragment;
}

var HTMLDisplay = function (_React$Component) {
  _inherits(HTMLDisplay, _React$Component);

  function HTMLDisplay() {
    _classCallCheck(this, HTMLDisplay);

    return _possibleConstructorReturn(this, (HTMLDisplay.__proto__ || Object.getPrototypeOf(HTMLDisplay)).apply(this, arguments));
  }

  _createClass(HTMLDisplay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // clear out all DOM element children
      // This matters on server side render otherwise we'll get both the `innerHTML`ed
      // version + the fragment version right after each other
      // In the desktop app (and successive loads with tools like commuter) this
      // will be a no-op
      if (!this.el) return;
      while (this.el.firstChild) {
        this.el.removeChild(this.el.firstChild);
      }
      // DOM element appended with a real DOM Node fragment
      this.el.appendChild(createFragment(this.props.data));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.data !== this.props.data;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.el) return;
      // clear out all DOM element children
      while (this.el.firstChild) {
        this.el.removeChild(this.el.firstChild);
      }
      this.el.appendChild(createFragment(this.props.data));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("div", {
        dangerouslySetInnerHTML: { __html: this.props.data },
        ref: function ref(el) {
          _this2.el = el;
        }
      });
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return HTMLDisplay;
}(_react2.default.Component);

HTMLDisplay.MIMETYPE = "text/html";
var _default = HTMLDisplay;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(createFragment, "createFragment", "src/html.js");
  reactHotLoader.register(HTMLDisplay, "HTMLDisplay", "src/html.js");
  reactHotLoader.register(_default, "default", "src/html.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/transforms/lib/html.js
// module id = 220
// module chunks = 186292428941015